import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../../services/authService';
import {
  setCredentials,
  setError,
  setStatus,
  selectAuthStatus,
  selectAuthError,
} from '../../redux/slices/authSlice';
import {
  PageContainer,
  Card,
  Title,
  Subtitle,
  Field,
  SubmitButton,
  SwitchLink,
  ErrorBox,
} from '../Login/auth.styles';

// Máscara de telefone BR: (XX) XXXXX-XXXX
const formatWhatsapp = (value) => {
  const d = (value || '').replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

const Cadastro = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const status = useSelector(selectAuthStatus);
  const error = useSelector(selectAuthError);

  // Origem do cadastro: quem veio do fluxo do CURSO (botão "Criar conta" na
  // página do curso → state.from = '/curso-de-fingerstyle') conta como 'course';
  // o resto (loja/e-book) conta como 'ebook'.
  const from = location.state?.from || '';
  const signupOrigin =
    location.state?.signupOrigin ||
    (String(from).includes('curso') ? 'course' : 'ebook');

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [whatsapp, setWhatsapp] = useState(''); // apenas dígitos
  const [password, setPassword] = useState('');

  const isSubmitting = status === 'loading';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      dispatch(setError('Senha deve ter no mínimo 8 caracteres'));
      return;
    }
    if (whatsapp.length < 10 || whatsapp.length > 11) {
      dispatch(setError('Informe um WhatsApp válido com DDD (ex.: (11) 91234-5678)'));
      return;
    }
    dispatch(setStatus('loading'));
    try {
      const { token, user } = await authService.register({ name, email, password, whatsapp, signupOrigin });
      dispatch(setCredentials({ token, user }));
      navigate('/minhas-compras', { replace: true });
    } catch (err) {
      dispatch(setError(err.message || 'Falha ao cadastrar'));
    }
  };

  return (
    <PageContainer>
      <Card onSubmit={handleSubmit} noValidate>
        <Title>Criar conta</Title>
        <Subtitle>Para acompanhar seus eBooks e cursos comprados</Subtitle>

        {error && <ErrorBox>{error}</ErrorBox>}

        <Field>
          Nome completo
          <input
            type="text"
            autoComplete="name"
            placeholder="Seu nome"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            minLength={2}
            disabled={isSubmitting}
          />
        </Field>

        <Field>
          E-mail
          <input
            type="email"
            autoComplete="email"
            placeholder="seu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isSubmitting}
          />
        </Field>

        <Field>
          WhatsApp
          <input
            type="tel"
            inputMode="numeric"
            autoComplete="tel"
            placeholder="(11) 91234-5678"
            value={formatWhatsapp(whatsapp)}
            onChange={(e) => setWhatsapp(e.target.value.replace(/\D/g, '').slice(0, 11))}
            required
            disabled={isSubmitting}
          />
        </Field>

        <Field>
          Senha (mín. 8 caracteres)
          <input
            type="password"
            autoComplete="new-password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            disabled={isSubmitting}
          />
        </Field>

        <SubmitButton type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Criando conta…' : 'Cadastrar'}
        </SubmitButton>

        <SwitchLink>
          Já tem conta? <Link to="/login">Entre</Link>
        </SwitchLink>
      </Card>
    </PageContainer>
  );
};

export default Cadastro;
